import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: stretch;
  @media (max-width: 768px) {
    flex-direction: column;
    min-height: 100vh;
    height: auto;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(231deg, #ececec, #ffffff, #f5f5f5);
  z-index: 1;
  padding: 0 73px 0 73px;
  overflow-y: auto;
  padding-bottom: 20px;
  @media (max-width: 768px) {
    padding: 30px;
    background-image: none;
    background-color: white;
    margin-top: -15px;
    padding-bottom: 53px;
    border-radius: 15px 15px 0 0;
    overflow-y: initial;
  }
`;

export const Body = styled.main`
  display: flex;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const ImageWeb = styled.img`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const ImageMobile = styled.img`
  @media (min-width: 769px) {
    display: none;
  }
`;

export const SideBanner = styled.div`
  width: 100%;
  max-width: 425.14px;
  height: 100%;
  background: ${({ theme }) => theme.gradient.top};

  padding: 49px 0px 0px 60px;

  > a {
    @media (max-width: 768px) {
      display: flex;
    }
  }

  svg {
    color: white;
    margin-bottom: 88.69px;
    height: 36.31px;
    width: 173.42px;
    path,
    .a {
      color: white;
      fill: white !important;
    }
  }

  img {
    margin-bottom: 88.69px;
    color: white;
    @media (max-width: 768px) {
      margin-bottom: 15px;
    }
  }

  @media (max-width: 769px) {
    padding: 25px 22.21px 15px 25px;
    max-width: 100%;

    svg {
      margin-bottom: 0px;
    }
  }
`;

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  span {
    font-size: 0.75rem;
    color: #5e5e5e;
    margin-bottom: 22px;
    color: ${({ theme }) => theme.colors.gray};

    display: flex;
    align-items: center;
  }

  h1 {
    font-size: 1.4375rem;
    margin-bottom: 12px;
    color: ${({ theme }) => theme.colors.blue};
  }

  h2 {
    font-size: 0.9375rem;
    margin-bottom: 18px;
    color: ${({ theme }) => theme.colors.gray};
    line-height: 30px;
    font-weight: 400px;
  }

  p {
    color: ${({ theme }) => theme.colors.black};
    font-weight: bold;
  }

`;
